import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EnterOutlinedSvg from "@ant-design/icons-svg/es/asn/EnterOutlined";
import AntdIcon from "../components/AntdIcon";
var EnterOutlined = function EnterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EnterOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EnterOutlined.displayName = 'EnterOutlined';
}
export default /*#__PURE__*/React.forwardRef(EnterOutlined);